import type CardLocation from '@alltrails/amplitude/enums/CardLocation';
import type MapLocation from '@alltrails/amplitude/enums/MapLocation';
import type TrailCardLocation from '@alltrails/amplitude/enums/TrailCardLocation';
import TrailheadVectorOverlay from '@alltrails/maps/components/TrailheadVectorOverlay/TrailheadVectorOverlay';
import { useExploreTrailUrl, useMapTrailNavigate } from '@/hooks/useTrailNavigate';
import { useLogExploreCardViewed } from '@/utils/analyticsHelpers';
import { useAppSelector } from '@/utils/redux';

type Props = {
  cardLocation: TrailCardLocation;
  detailedCardLocation: CardLocation;
  mapLocation: MapLocation | string;
  handleFavoriteClick?: (trailId: number) => void;
};

const TrailheadMapComponents = ({ cardLocation, detailedCardLocation, mapLocation, handleFavoriteClick }: Props) => {
  const logExploreCardViewed = useLogExploreCardViewed('trail');
  const onTrailNavigate = useMapTrailNavigate();
  const getExploreTrailUrl = useExploreTrailUrl();
  const { mapPadding, activityType } = useAppSelector(state => ({
    mapPadding: state.explore.mapPadding,
    activityType: state.exploreService.filters?.activity?.[0]
  }));

  return (
    <TrailheadVectorOverlay
      activityType={activityType}
      cardLocation={cardLocation}
      detailedCardLocation={detailedCardLocation}
      getTrailCardUrl={getExploreTrailUrl}
      handleFavoriteClick={handleFavoriteClick}
      mapLocation={mapLocation}
      onTrailCardViewed={logExploreCardViewed}
      onTrailNavigate={onTrailNavigate}
      mapPadding={mapPadding}
    />
  );
};

export default TrailheadMapComponents;
